import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'What license do I need to drive the horsebox?',
      answer: 'A Full UK Driving License (Category B) is required and must have been held for 2 years with no more than 2 minor convictions or 6 points in the last 5 years.'
    },
    {
      question: 'How do I make a booking?',
      answer: 'You can book by completing our Booking Enquiry Form on this website, or by contacting us via email at enquiries@equi-go.co.uk or calling/WhatsApp at 07788 754165.'
    },
    {
      question: 'What is the payment process?',
      answer: 'A £50 prepayment is required to secure your booking. A £200 refundable security deposit is also required on or before collection day. The deposit is returned within 24 hours once the horsebox is returned safely and undamaged. All payments must be made by bank transfer.'
    },
    {
      question: 'What areas do you cover?',
      answer: 'We are based in North Yorkshire between Harrogate and Boroughbridge. The horsebox can be collected from our location. Up to 300 miles per day are included in the hire. Additional mileage is subject to an additional charge.'
    },
    {
      question: 'Is the horsebox insured?',
      answer: (
        <>
          Yes, our horsebox is insured for drivers aged 25-75. Please refer to our{' '}
          <a href="/terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline font-semibold">
            Terms and Conditions
          </a>{' '}
          for full details. We may be able to help if you are not covered by our standard policy - contact us to discuss.
        </>
      )
    },
    {
      question: 'Can I hire for half a day at weekends?',
      answer: 'No, half-day hire is only available Monday to Thursday. Weekend and bank holiday bookings are full-day only. However, we offer a special weekend rate of £225 for Saturday and Sunday combined.'
    },
    {
      question: 'What happens if I need to cancel my booking?',
      answer: (
        <>
          Please refer to our{' '}
          <a href="/terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline font-semibold">
            Terms and Conditions
          </a>{' '}
          for our cancellation policy. Contact us as soon as possible if you need to cancel or reschedule your booking.
        </>
      )
    },
    {
      question: 'Is the horsebox suitable for one or two horses?',
      answer: 'The horsebox is stalled for two horses with a maximum total payload of 1,050kg.'
    },
    {
      question: 'What if I have an issue during my hire?',
      answer: 'We provide full support during your hire period. You can contact us via phone or WhatsApp at 07788 754165 if you need any assistance or have concerns.'
    },
    {
      question: 'When will the online booking system be available?',
      answer: 'Our online Booking Enquiry Form is now available on this website. Simply scroll down to the contact section to submit your enquiry.'
    }
  ];

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-['Playfair_Display']">
            Frequently Asked <span className="text-[#2d5f3f]">Questions</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Find answers to common questions about our horsebox hire service. 
            Can't find what you're looking for? Contact us directly.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl px-6 hover:border-[#2d5f3f]/30 transition-all duration-300 shadow-sm hover:shadow-md"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-[#2d5f3f] transition-colors duration-200 py-6 text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Still Have Questions CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-br from-[#2d5f3f] to-[#1e4029] rounded-2xl p-8 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-3">
              Still Have Questions?
            </h3>
            <p className="text-white/90 mb-6 max-w-xl mx-auto">
              Our friendly team is here to help. Get in touch and we'll be happy to assist you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:07788754165"
                className="px-8 py-3 bg-white text-[#2d5f3f] rounded-lg hover:bg-gray-100 transition-colors duration-300 font-semibold"
              >
                Call 07788 754165
              </a>
              <a
                href="mailto:enquiries@equi-go.co.uk"
                className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg hover:bg-white/20 transition-colors duration-300 font-semibold"
              >
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;